/**
 * Shared system-prompt fragment that every AI flow in the addin appends
 * so the LLM treats tracked-change deletions as already-accepted edits.
 *
 * Why this exists:
 *   When the addin calls Word.js `body.text` to get the document content,
 *   Word includes BOTH the deleted (strikethrough) text and the inserted
 *   replacement text — e.g. "for a period of five (5) years two (2) years".
 *   Without explicit guidance the LLM reads both and either flags the
 *   already-fixed wording as still failing, or repeats the deletion
 *   verbatim in its output.
 *
 *   Server-side flows (e.g. the playbook run endpoint) already use the
 *   `extractAcceptedText` helper on the .docx XML. This file is the
 *   client-side equivalent: a prompt-level instruction added to every
 *   AI request that ships document text from the addin.
 *
 * Usage:
 *   const systemMessage = LEGAL_ANALYST_SYSTEM + TRACKED_CHANGES_GUIDANCE;
 */

export const TRACKED_CHANGES_GUIDANCE = `

IMPORTANT — handling tracked changes:
- The document text below may contain tracked changes from a redline.
- Treat the document as if every tracked change has already been ACCEPTED.
- IGNORE any text that appears struck through, marked as a deletion, or
  preceded by markers like "[DELETED]", "<del>", or "- ". That content has
  been removed from the contract and should not influence your analysis.
- Treat inserted / added text as final contract wording.
- If you see what looks like two consecutive contradictory phrases that
  came from "deleted + inserted" content, use the second one (the
  insertion) as the truth.`;
